export function hasBookableArena(slots, team) {
    if (!Array.isArray(slots)) return false;

    return slots.some((slot) => (
        slot?.bookable === true
        && slot.arena_public !== false
        && slot.max_seats - slot.booked_seats >= team
    ));
}
